import { render, staticRenderFns } from "./newsDetails.vue?vue&type=template&id=cd74fa4a&scoped=true"
import script from "./newsDetails.vue?vue&type=script&lang=js"
export * from "./newsDetails.vue?vue&type=script&lang=js"
import style0 from "./newsDetails.vue?vue&type=style&index=0&id=cd74fa4a&lang=scss&scoped=true"
import style1 from "./newsDetails.vue?vue&type=style&index=1&id=cd74fa4a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd74fa4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd74fa4a')) {
      api.createRecord('cd74fa4a', component.options)
    } else {
      api.reload('cd74fa4a', component.options)
    }
    module.hot.accept("./newsDetails.vue?vue&type=template&id=cd74fa4a&scoped=true", function () {
      api.rerender('cd74fa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/newsDetails.vue"
export default component.exports